/* eslint-disable max-len */
const loginUiTexts = {
	adminBtn: {
		en: 'Administrator',
		de: 'Administrator',
		ja: '管理者（アドミニストレーター）',
		pt: 'Administrador'
	},
	login: {
		en: 'Login',
		de: 'Login',
		ja: 'ログイン',
		pt: 'Iniciar sessão'
	},
	facilitator: {
		en: 'Facilitator',
		de: 'Spielleiter',
		ja: 'ファシリテーター',
		pt: 'Facilitador'
	},
	group: {
		en: 'Group',
		de: 'Gruppe',
		ja: 'グループ',
		pt: 'Grupo'
	},
	email: {
		en: 'e-mail',
		de: 'E-Mail',
		ja: 'グループ',
		pt: 'e-mail'
	},
	password: {
		en: 'password',
		de: 'Passwort',
		ja: 'パスワード',
		pt: 'palavra-passe'
	},
	gameCode: {
		en: 'game code',
		de: 'Spielcode',
		ja: 'ゲームコード',
		pt: 'código do jogo'
	},
	forgotPassword: {
		en: 'Forgot your password?',
		de: 'Passwort vergessen?',
		ja: 'パスワードをお忘れですか？',
		pt: 'Esqueceu-se da palavra-passe?'
	},
	backToLogin: {
		en: 'Go back to login',
		de: 'Zurück zum Login',
		ja: 'ログインに戻る',
		pt: 'Voltar ao início de sessão'
	},
	resetPassword: {
		en: 'Enter your e-mail to reset your password:',
		de: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen:',
		ja: 'パスワードをリセットするためＥメールを入力してください:',
		pt: 'Introduza o seu e-mail para redefinir a sua palavra-passe:'
	},
	reset: {
		en: 'Reset',
		de: 'Zurücksetzen',
		ja: 'リセット',
		pt: 'Redefinir'
	},
	cancel: {
		en: 'Cancel',
		de: 'Abbrechen',
		ja: 'キャンセル',
		pt: 'Cancelar'
	},
	passwordResetFeedback: {
		en: 'A link to reset your password has been sent to your e-mail.',
		de: 'Es wurde ein Link zum Zurücksetzen Ihres Passworts an Ihre E-Mail gesendet.',
		ja: 'パスワードをリセットするためのリンクがＥメールに送信されました。',
		pt: 'Foi enviado um link para redefinir a sua palavra-passe para o seu e-mail'
	},
	unknownError: {
		en: 'Error: unknown error',
		de: 'Fehler: unbekannter Fehler',
		ja: 'エラー: 不明なエラー',
		pt: 'Erro: erro desconhecido'
	},
	someFieldsMissing: {
		en: 'Error: Please fill out all fields',
		de: 'Fehler: Bitte füllen Sie alle Felder aus',
		ja: 'エラー: 全てのフィールドに入力してください',
		pt: 'Erro: Preencha todos os campos'
	},
	gameNotFound: {
		en: 'Error: Game not found',
		de: 'Fehler: Spiel nicht gefunden',
		ja: 'エラー: ゲームが見つかりません',
		pt: 'Erro: Jogo não encontrado'
	},
	invalidEmail: {
		en: 'Error: Invalid e-mail',
		de: 'Fehler: Ungültige E-Mail',
		ja: 'エラー: 無効なEメール',
		pt: 'Erro: E-mail inválido'
	},
	userNotFound: {
		en: 'Error: User not found',
		de: 'Fehler: Benutzername falsch',
		ja: 'エラー: ユーザーが見つかりません',
		pt: 'Erro: Utilizador não encontrado'
	},
	userNotFacilitator: {
		en: 'Error: You do not have facilitator access.',
		de: 'Fehler: Sie haben keinen Spielleiter-Zugang.',
		ja: 'エラー: ファシリテーターとしてのアクセス権がありません。',
		pt: 'Erro: Não tem permissões de facilitador'
	},
	invalidPassword: {
		en: 'Error: Wrong password',
		de: 'Fehler: Falsches Passwort',
		ja: 'エラー: 誤ったパスワード',
		pt: 'Erro: Palavra-passe incorreta'
	},
	notAvailable: {
		en: 'Error: This game is no longer available',
		de: 'Fehler: Dieses Spiel ist nicht mehr verfügbar',
		ja: 'エラー: このゲームは現在利用できません',
		pt: 'Erro: Este jogo já não está disponível'
	},
	couldNotFindCompany: {
		en: 'Error: Could not find company',
		de: 'Fehler: Firma konnte nicht gefunden werden',
		ja: 'エラー: カンパニーが見つかりません',
		pt: 'Erro: Não foi possível encontrar a empresa'
	},
	notAuthorized: {
		en: 'Error: You are not authorized as admin',
		de: 'Fehler: Sie sind nicht als Admin autorisiert',
		ja: 'エラー: 管理者権限がありません',
		pt: 'Erro: Não está autorizado como administrador'
	},
	error: {
		en: 'Error',
		de: 'Fehler',
		ja: 'エラー',
		pt: 'Erro'
	}
};


const settingsUiTexts = {
	overview: {
		en: 'Overview',
		de: 'Übersicht',
		ja: '概要',
		pt: 'Visão geral'
	},
	createGame: {
		en: 'Create game',
		de: 'Spiel erstellen',
		ja: 'ゲームの作成',
		pt: 'Criar jogo'
	},
	myGames: {
		en: 'My games',
		de: 'Meine Spiele',
		ja: 'マイ・ゲーム',
		pt: 'Os meus jogos'
	},
	allGames: {
		en: 'All games',
		de: 'Alle Spiele',
		ja: '全てのゲーム',
		pt: 'Todos os jogos'
	},
	play: {
		en: 'Play',
		de: 'Spielen',
		ja: 'プレイ',
		pt: 'Iniciar'
	},
	active: {
		en: 'Active',
		de: 'Aktiv',
		ja: 'アクティブ',
		pt: 'Ativo'
	},
	edit: {
		en: 'Edit',
		de: 'Bearbeiten',
		ja: '編集',
		pt: 'Editar'
	},
	gameCode: {
		en: 'Game code',
		de: 'Spielcode',
		ja: 'ゲームコード',
		pt: 'Código do jogo'
	},
	deleteGamePopup: {
		title: {
			en: 'Delete game',
			de: 'Spiel löschen',
			ja: 'ゲームの削除',
			pt: 'Eliminar jogo'
		},
		areYouSure: {
			en: 'Are you sure you want to delete the game %game%',
			de: 'Sind Sie sicher, dass Sie das Spiel XXX löschen möchten?',
			ja: 'ゲーム %game% を削除してもよいですか',
			pt: 'Tem a certeza que pretende eliminar o jogo %game%?'
		},
		delete: {
			en: 'Delete',
			de: 'Löschen',
			ja: '削除',
			pt: 'Eliminar'
		},
		cancel: {
			en: 'Cancel',
			de: 'Abbrechen',
			ja: 'キャンセル',
			pt: 'Cancelar'
		},
	},
	home: {
		en: 'Home',
		de: 'Startseite',
		ja: 'ホーム',
		pt: 'Início'
	},
	editGame: {
		en: 'Edit game',
		de: 'Spiel bearbeiten',
		ja: 'ゲームの編集',
		pt: 'Editar jogo'
	},
	createdBy: {
		en: 'Created by',
		de: 'Erstellt von',
		ja: '作成',
		pt: 'Criado por'
	},
	company: {
		en: 'Company',
		de: 'Firma',
		ja: 'カンパニー',
		pt: 'Empresa'
	},
	gameTitle: {
		en: 'Game session title',
		de: 'Titel der Spielsitzung',
		ja: 'ゲームセッション・タイトル',
		pt: 'Título da sessão de jogo'
	},
	gameTitlePlaceholder: {
		en: 'enter title',
		de: 'Titel eingeben',
		ja: 'タイトルを入力してください',
		pt: 'Introduza o título'
	},
	gameDate: {
		en: 'Date for game session',
		de: 'Datum der Spielsitzung',
		ja: 'ゲームセッションの日付',
		pt: 'Data da sessão de jogo'
	},
	scenario: {
		en: 'Scenario type',
		de: 'Szenario-Typ',
		ja: 'シナリオタイプ',
		pt: 'Tipo de cenário'
	},
	decisionTool: {
		en: 'Decision making tool',
		de: 'Enscheidungshilfe',
		ja: '意思決定ツール',
		pt: 'Ferramenta de tomada de decisão'
	},
	communicationTool: {
		en: 'Communication tool',
		de: 'Kommunikationstool',
		ja: 'コミュニケーションツール',
		pt: 'Ferramenta de comunicação'
	},
	exerciseTool: {
		en: 'Exercise tool',
		de: 'Übungstool',
		ja: '演習ツール',
		pt: 'Ferramenta de treino'
	},
	language: {
		en: 'Language',
		de: 'Sprache',
		ja: '言語',
		pt: 'Idioma'
	},
	create: {
		en: 'Create',
		de: 'Erstellen',
		ja: '作成',
		pt: 'Criar'
	},
	save: {
		en: 'Save',
		de: 'Speichern',
		ja: '保存',
		pt: 'Guardar'
	},
	numberOfGroups: {
		en: 'Number of groups',
		de: 'Anzahl der Gruppen',
		ja: 'グループの数',
		pt: 'Número de grupos'
	},
	group: {
		en: 'Group',
		de: 'Gruppe',
		ja: 'グループ',
		pt: 'Grupo'
	},
	groups: {
		en: 'Groups',
		de: 'Gruppen',
		ja: '(複数)グループ',
		pt: 'Grupos'
	},
	startTypingPlayerName: {
		en: 'Start typing player name',
		de: 'Spielername',
		ja: 'プレイヤーの名前をタイプしてください',
		pt: 'Comece a escrever o nome do jogador'
	},
	noMatchingNames: {
		en: 'No matching names',
		de: 'Keine passenden Namen',
		ja: '名前が一致しません',
		pt: 'Nenhum nome correspondente'
	},
	allNamesAdded: {
		en: 'All names are added',
		de: 'Alle Namen werden hinzugefügt',
		ja: '全ての名前が追加されました',
		pt: 'Todos os nomes foram adicionados'
	},
	missingGameTitle: {
		en: 'You must enter a game title',
		de: 'Sie müssen einen Spieltitel eingeben',
		ja: 'ゲームタイトルを入力してくださいa',
		pt: 'Deve introduzir um título para o jogo'
	},
	gameTitleMaxLength: {
		en: 'The game title must be max %chars% characters long',
		de: 'Der Spieltitel darf maximal %chars% Zeichen lang sein',
		ja: 'ゲームタイトルは最大 %chars% 文字の長さです',
		pt: 'O título do jogo deve ter no máximo %chars% caracteres'
	},
	saveBeforePrint: {
		en: 'You need to create the game before you can print',
		de: 'Sie müssen das Spiel erst erstellen, bevor Sie es ausdrucken können',
		ja: 'プリントの前にゲームを作成する必要があります',
		pt: 'Tem de criar o jogo antes de poder imprimir'
	},
	gameUrl: {
		en: 'Game URL: ',
		de: 'URL des Spiels: ',
		ja: 'ゲーム URL:',
		pt: 'URL do jogo:'
	},
	scheduledStart: {
		en: 'Scheduled start date',
		de: 'Geplanter Starttermin',
		ja: 'スケジュールされた開始日',
		pt: 'Data de início agendada'
	},
	createdDate: {
		en: 'Created date',
		de: 'Erstelltes Datum',
		ja: '作成日',
		pt: 'Data de criação'
	},
	currentGamePhase: {
		en: 'Current game phase',
		de: 'Aktuelle Spielphase',
		ja: '現在のゲームフェーズ',
		pt: 'Fase atual do jogo'
	},
	currentGameStep: {
		en: 'Current game step',
		de: 'Aktueller Spielschritt',
		ja: '現在のゲームステップ',
		pt: 'Passo atual do jogo'
	},
	goToNextGamePhase: {
		en: 'Open next phase',
		de: 'Nächste Phase öffnen',
		ja: '次のフェーズを開く',
		pt: 'Abrir a próxima fase'
	},
	openNextGamePhase: {
		en: 'Open',
		de: 'Öffnen',
		ja: '開く',
		pt: 'Abrir'
	},
	finishGame: {
		en: 'Finish game',
		de: 'Spiel beenden',
		ja: 'ゲームの終了',
		pt: 'Terminar jogo'
	},
	nextPhaseWarningPopup: {
		title: {
			en: 'Warning',
			de: 'Warnung',
			ja: '警告',
			pt: 'Aviso'
		},
		text: {
			en: 'Some groups have not completed the current phase. Do you still want to open the next phase?',
			de: 'Einige Gruppen haben die aktuelle Phase noch nicht abgeschlossen. Möchten Sie trotzdem die nächste Phase eröffnen?',
			ja: '現在のフェーズを終了していないグループがあります。それでも次のフェーズを開きますか？',
			pt: 'Alguns grupos não concluíram a fase atual. Pretende abrir a próxima fase mesmo assim?'
		},
		confirm: {
			en: 'Confirm',
			de: 'Bestätigen',
			ja: '確認',
			pt: 'Confirmar'
		},
		cancel: {
			en: 'Cancel',
			de: 'Abbrechen',
			ja: 'キャンセル',
			pt: 'Cancelar'
		}
	},
	status: {
		en: 'Status',
		de: 'Status',
		ja: 'ステータス',
		pt: 'Estado'
	},
	noStatusPopup: {
		title: {
			en: 'Status',
			de: 'Status',
			ja: 'ステータス',
			pt: 'Estado'
		},
		text: {
			en: 'The status shows an overview of group responses on debriefs. It is only active when all groups have completed the debrief. In rounds without debriefs, there is no status overview.',
			de: 'Der Status zeigt einen Überblick über die Antworten der Gruppen zur Nachbesprechung. Runden ohne Nachbesprechung können nicht angezeigt werden.',
			ja: 'ステータスは、デブリーフィングに関するグループの回答の概要を表示します。このステータスは、すべてのグループがデブリーフィングを完了したときのみアクティブになります。デブリーフィングがないラウンドでは、ステータスの概要は表示されません。',
			pt: 'O estado apresenta uma visão geral das respostas dos grupos nos debriefings. Só está ativo quando todos os grupos concluíram o debriefing. Nas rondas sem debriefings, não existe visão geral do estado.'
		}
	},
	pause: {
		en: 'Pause',
		de: 'Pause',
		ja: '一時停止',
		pt: 'Pausar'
	},
	unpause: {
		en: 'Unpause',
		de: 'Pause beenden',
		ja: '一時停止の終了',
		pt: 'Retomar'
	},
};


const generalUiTexts = {
	welcome: {
		en: 'Welcome',
		de: 'Wilkommen',
		ja: 'ようこそ',
		pt: 'Bem-vindo'
	},
	group: {
		en: 'Group',
		de: 'Gruppe',
		ja: 'グループ',
		pt: 'Grupo'
	},
	start: {
		en: 'Start',
		de: 'Start',
		ja: '開始',
		pt: 'Iniciar'
	},
	continue: {
		en: 'Continue',
		de: 'Fortsetzen',
		ja: '続行',
		pt: 'Continuar'
	},
	next: {
		en: 'Next',
		de: 'Weiter',
		ja: '次へ',
		pt: 'Seguinte'
	},
	ok: {
		en: 'OK',
		de: 'OK',
		ja: 'OK',
		pt: 'OK'
	},
	confirm: {
		en: 'Confirm',
		de: 'Bestätigen',
		ja: '確認',
		pt: 'Confirmar'
	},
	submit: {
		en: 'Submit',
		de: 'Abschicken',
		ja: '送信',
		pt: 'Submeter'
	},
	cancel: {
		en: 'Cancel',
		de: 'Abbrechen',
		ja: 'キャンセル',
		pt: 'Cancelar'
	},
	paused: {
		en: 'Game paused',
		de: 'Spiel pausieren',
		ja: 'ゲームの一時停止',
		pt: 'Jogo em pausa'
	},
	waiting: {
		en: 'Waiting for facilitator...',
		de: 'Warten auf Spielleiter...',
		ja: 'ファシリテーターを待っています...',
		pt: 'A aguardar o facilitador...'
	},

	crewInfo: {
		en: 'Crew Information',
		de: 'Crew Informationen',
		ja: 'クルーの情報',
		pt: 'Informações da Tripulação'
	},
	flightInfo: {
		en: 'Flight Information',
		de: 'Flug-Informationen',
		ja: 'フライトの情報',
		pt: 'Informações do Voo'
	},
	preflightBriefing: {
		en: 'Preflight briefing',
		de: 'Vorflug-Briefing',
		ja: '飛行前のブリーフィング(打ち合わせ）',
		pt: 'Briefing pré-voo'
	},
	briefing: {
		en: 'Briefing',
		de: 'Briefing',
		ja: 'ブリーフィング（打ち合わせ）',
		pt: 'Briefing'
	},
	briefings: {
		en: 'Briefings',
		de: 'Briefings',
		ja: 'ブリーフィング',
		pt: 'Briefings'
	},
	statusUpdate: {
		en: 'Status update',
		de: 'Status Update',
		ja: 'ステータスの更新',
		pt: 'Atualização de estado'
	},
	locationInfoPopup: {
		en: 'You have to check the weather conditions at each location before you can close this popup.',
		de: 'Bevor Sie dieses Popup schließen können, müssen Sie die Wetterbedingungen an jedem Ort überprüfen.',
		ja: 'このポップアップを閉じるには、各地点の天候を確認する必要があります。',
		pt: 'É necessário verificar as condições meteorológicas em cada localização antes de fechar esta janela.'
	},
	
	title: {
		en: 'Title',
		de: 'Titel',
		ja: 'タイトル',
		pt: 'Título'
	},
	age: {
		en: 'Age',
		de: 'Alter',
		ja: '年齢',
		pt: 'Idade'
	},
	crewExperience: {
		en: 'Crew experience',
		de: 'Crew Erfahrung',
		ja: 'クルーの経験',
		pt: 'Experiência da tripulação'
	},
	personalIssues: {
		en: 'Personal issues',
		de: 'Personliche Probleme',
		ja: '個人の問題点',
		pt: 'Problemas pessoais'
	},
	certifyingStaffOnly: {
		en: 'For CERTIFYING STAFF only',
		de: 'Nur für Freigabeberechtigtes Personal',
		ja: 'CERTIFYING STAFFのみ',
		pt: 'Apenas para PESSOAL CERTIFICADOR'
	},
	heliCrewCardBackText: {
		en: 'Here you see %names% degree of experience and personal issues',
		de: 'Hier sehen Sie %names% Erfahrungsgrad und persönliche Probleme',
		ja: 'ここでは、%names%の経験度や個人的な問題点を見ることができます。',
		pt: 'Aqui pode ver o nível de experiência e os problemas pessoais de %names%'
	},
	crewFeedbackInstructionsTitle: {
		en: 'Selected crew',
		de: 'Ausgewählte Crew',
		ja: '選択されたクルー',
		pt: 'Tripulação selecionada'
	},
	crewFeedbackInstructionsText: {
		en: 'Flip the cards to see what effects your crew selection has. You might get RISK and / or DIRTY DOZEN.<br /><br />Once you have turned all crew cards you are ready to continue.',
		de: 'Drehen Sie die Karten um, um zu sehen, welche Auswirkungen die Auswahl Ihrer Mannschaft hat. Du könntest RISIKOS und / oder DIRTY DOZENS erhalten.<br /><br />Sobald Sie alle Crew-Karten umgedreht haben, können Sie fortfahren.',
		ja: 'カードをめくって、自分の選んだクルーがどのような効果を持つかを確認します。RISK / もしくはDIRTY DOZENを知ることができます。<br /><br />すべてのクルーカードをひっくり返すと、続行する準備が整います。',
		pt: 'Vire os cartões para ver os efeitos da sua seleção de tripulação. Pode obter RISK e/ou DIRTY DOZEN.<br /><br />Depois de virar todos os cartões da tripulação, está pronto para continuar.'
	},
	crewFeedbackInstructionsTextHeli: {
		en: 'Flip the cards to see your crew\'s experience and personal issues. The technical crew has experience in both paramedic and system operation, but benefits primarily from the role you have assigned on this mission.<br /><br />Once you have turned all crew cards you are ready to continue.',
		de: 'Drehen Sie die Karten um, um zu sehen, welche Erfahrungen und persönlichen Probleme Ihre Crew hat. Die technische Crew hat sowohl Erfahrung im Sanitätsdienst als auch im Systembetrieb, profitiert aber in erster Linie von der Rolle, die Sie ihnen zugewiesen haben.<br /><br />Sobald Sie alle Crew-Karten umgedreht haben, können Sie fortfahren.',
		ja: 'カードをめくって、クルー達の経験や個人的な問題点を確認します。テクニカルクルーは、救急措置とシステム運用の両方の経験を持っていますが、このミッションであなたが割り当てた役割を主に得ています。<br /><br />すべてのクルーカードをひっくり返すと、続行する準備が整います。',
		pt: 'Vire os cartões para ver a experiência e os problemas pessoais da sua tripulação. A tripulação técnica tem experiência tanto em atividades paramédicas como na operação de sistemas, mas beneficia principalmente da função atribuída nesta missão.<br /><br />Depois de virar todos os cartões da tripulação, está pronto para continuar.'
	},

	reflection: {
		textPlaceholder: {
			en: 'Type your answer here',
			de: 'Geben Sie hier Ihre Antwort ein',
			ja: '回答をここに記入してください',
			pt: 'Introduza aqui a sua resposta'
		},
		notAtAll: {
			en: 'Not at all',
			de: 'Überhaupt nicht',
			ja: 'まったくない',
			pt: 'De forma alguma'
		},
		extremely: {
			en: 'Extremely',
			de: 'Äußerst',
			ja: '非常に',
			pt: 'Extremamente'
		},
		question: {
			en: 'Question',
			de: 'Frage',
			ja: '質問',
			pt: 'Pergunta'
		},
		unknownReflection: {
			en: 'Unknown reflection',
			de: 'Unbekannte Reflexion ',
			ja: '不明な振り返り',
			pt: 'Reflexão não identificada'
		},
		tool: {
			en: 'Tool',
			de: 'Werkzeug',
			ja: 'ツール',
			pt: 'Ferramenta'
		},
		incident: {
			en: 'Incident',
			de: 'Vorfall',
			ja: 'インシデント(出来事）',
			pt: 'Incidente'
		},
		topics: {
			en: 'Topics',
			de: 'Themen',
			ja: 'トピックス',
			pt: 'Tópicos'
		},
	},

	dirtyDozen: {
		en: 'Dirty Dozens',
		de: 'Dirty Dozen',
		ja: 'ダーティ・ダズン(Dirty Dozens)',
		pt: 'Dirty Dozen'
	},
	dirtyDozen2: {
		en: 'Dirty Dozen',
		de: 'Dirty Dozens',
		ja: 'ダーティ・ダズン(Dirty Dozens)',
		pt: 'Dirty Dozens'
	},
	inconvenience: {
		en: 'Inconvenience',
		de: 'Unannehmlichkeiten',
		ja: '不便さ',
		pt: 'Inconveniência'
	},
	risk: {
		en: 'Risk',
		de: 'Risiko',
		ja: 'リスク',
		pt: 'Risco'
	},
	doubleRisk: {
		en: 'Risk (x2)',
		de: 'Risiko (x2)',
		ja: 'リスク (x2)',
		pt: 'Risco (x2)'
	},
	extraRisk: {
		en: 'Extra risk',
		de: 'Zusätzliches Risiko',
		ja: '非常に大きなリスク',
		pt: 'Risco extra'
	},
	extraTime: {
		en: 'Extra time',
		de: 'Zusätzlicher Zeitaufwand',
		ja: '余計な時間',
		pt: 'Tempo extra'
	},
	extraCost: {
		en: 'Extra cost',
		de: 'Zusätzliche Kosten',
		ja: '余計なコスト',
		pt: 'Custo extra'
	},
	crewSafety: {
		en: 'Crew Safety',
		de: 'Sicherheit der Crew',
		ja: 'クルーの安全',
		pt: 'Segurança da tripulação'
	},
	missionSuccess: {
		en: 'Mission Success',
		de: 'Erfolg der Mission',
		ja: 'ミッションの成功',
		pt: 'Sucesso da missão'
	},
	compliance: {
		en: 'Compliance',
		de: 'Einhaltung',
		ja: 'コンプライアンス（法令遵守）',
		pt: 'Conformidade'
	},
	resources: {
		en: 'Resources',
		de: 'Ressourcen',
		ja: 'リソース',
		pt: 'Recursos'
	},
	threats: {
		en: 'Threats',
		de: 'Bedrohung',
		ja: 'スレット（脅威）',
		pt: 'Ameaças'
	},

	crewPopupTitle: {
		en: 'Crew',
		de: 'Crew',
		ja: 'クルー',
		pt: 'Tripulação'
	},
	groupsPopupTitle: {
		en: 'Groups',
		de: 'Gruppen',
		ja: 'グループ',
		pt: 'Grupos'
	},

	defaultThisTurn: {
		en: 'Default THIS turn',
		de: 'Vorgabe in DIESER Runde',
		ja: '対処しない場合、この場面では',
		pt: 'Padrão NESTE turno'
	},
	defaultNextTurn: {
		en: 'Default next turn',
		de: 'Vorgabe in der nächsten Runde',
		ja: '対処しない場合、次の場面では',
		pt: 'Padrão no turno seguinte'
	},
	noDefaultOption: {
		en: 'NO DEFAULT, you must choose',
		de: 'Keine Vorgaben, Sie müssen wählen',
		ja: 'デフォルトなし、選択する必要があります',
		pt: 'SEM PADRÃO, deve escolher uma opção'
	},
	free: {
		en: 'Free',
		de: 'Frei',
		ja: 'フリー',
		pt: 'Livre'
	},
	movesToNextRound: {
		en: 'Moves to next turn',
		de: 'In die nächste Runde',
		ja: '次のターンへ移動する',
		pt: 'Passa para o próximo turno'
	},
	callFacilitator: {
		en: 'CALL FACILITATOR',
		de: 'Spielleiter rufen',
		ja: 'ファシリテーターを呼ぶ',
		pt: 'CHAMAR O FACILITADOR'
	},

	warning: {
		en: 'Warning',
		de: 'Warnung',
		ja: '警告',
		pt: 'Aviso'
	},
	requiredOptionsWarning: {
		en: 'One or more cards require that you select an option.',
		de: 'Eine oder mehrere Karten verlangen, dass Sie eine Auswahl treffen.',
		ja: '１つかそれ以上のカードでオプションを選ぶ必要があります',
		pt: 'Uma ou mais cartas exigem que selecione uma opção.'
	},
	resourceWarning: {
		en: 'You have not placed all your resources, are you sure you want to confirm?',
		de: 'Sie haben noch nicht alle Ihre Ressourcen eingesetzt. Sind Sie sicher, dass Sie das bestätigen wollen?',
		ja: 'すべてのリソースを配置していませんが、本当に確認しますか？',
		pt: 'Não colocou todos os seus recursos. Tem a certeza de que pretende confirmar?'
	},
	turnCard: {
		en: 'Turn card',
		de: 'Karte drehen',
		ja: 'カードをめくる',
		pt: 'Virar cartão'
	},
	nextTurn: {
		en: 'Next turn',
		de: 'Nächster Zug',
		ja: '次のターン',
		pt: 'Turno seguinte'
	},
	youGet: {
		en: 'You get',
		de: 'Sie erhalten',
		ja: '入手・了解',
		pt: 'Recebe'
	},
	noDirtyDozen: {
		en: 'You get no Dirty Dozen',
		de: 'Sie erhalten keine Dirty Dozen',
		ja: 'ダーティ・ダズンを承知していません',
		pt: 'Não recebe nenhum Dirty Dozen'
	},
	newDirtyDozen: {
		en: 'received a new Dirty Dozen',
		de: 'erhält ein neues Dirty Dozen', 
		ja: 'は新しいダーティ・ダズンを受け取りました',
		pt: 'recebeu um novo Dirty Dozen'
	},
	extraDirtyDozen: {
		en: 'already has %dd%. Proceed with caution!',
		de: 'hat bereits %dd%. Seien Sie vorsichtig!',
		ja: 'は既に%dd%を持っています。注意して続行してください！',
		pt: 'já tem %dd%. Proceda com cautela!'
	},
	multiDirtyDozen: {
		en: 'already has double %dd%!',
		de: 'hat bereits doppelte %dd%!',
		ja: 'はすでに２つ%dd%を持っています！',
		pt: 'já tem o dobro de %dd%!'
	},

	taskExtraTime: {
		en: 'This task took extra time',
		de: 'Diese Aufgabe kostete extra Zeit',
		ja: 'このタスクは更なる時間がかかりました',
		pt: 'Esta tarefa exigiu mais tempo'
	},
	taskExtraRisk: {
		en: 'This task increased the risk',
		de: 'Diese Aufgabe erhöhte das Risiko',
		ja: 'このタスクはリスクを増やしました',
		pt: 'Esta tarefa aumentou o risco'
	},
	taskExtraCost: {
		en: 'This task increased the cost',
		de: 'Diese Aufgabe erhöhte die Kosten',
		ja: 'このタスクはコストを増やしました',
		pt: 'Esta tarefa aumentou o custo'
	},
	is: {
		en: 'is',
		de: 'ist',
		ja: 'は',
		pt: 'é'
	},
	has: {
		en: 'has',
		de: 'hat',
		ja: 'は',
		pt: 'tem'
	},

	flipCards: {
		en: 'Flip the cards and gain the benefits',
		de: 'Drehen Sie die Karten, um die Vorteile zu sehen',
		ja: 'カードをめくり、ベネフィットを得てください',
		pt: 'Vire os cartões e obtenha os benefícios'
	},

	extra: {
		en: 'Extra',
		de: 'Extra',
		ja: 'エクストラ（追加・余分）',
		pt: 'Adicional'
	},
	youChose: {
		en: 'You chose',
		de: 'Sie wählten',
		ja: '選びました',
		pt: 'Escolheu'
	},

	results: {
		en: 'Results',
		de: 'Ergebnisse',
		ja: '結果',
		pt: 'Resultados'
	},
	total: {
		en: 'Total',
		de: 'Gesamt',
		ja: 'トータル',
		pt: 'Total'
	},
};

const gamePhasesUiTexts = {
	crewSelection: {
		en: 'Crew Selection',
		de: 'Crew Auswahl',
		ja: 'クルー選択',
		pt: 'Seleção da tripulação'
	},
	staffSelection: {
		en: 'Staff selection',
		de: 'Mitarbeiter Auswahl',
		ja: 'スタッフ選択',
		pt: 'Seleção de pessoal'
	},
	onTheGround: {
		en: 'On the ground',
		de: 'Am Boden',
		ja: '地上',
		pt: 'Em terra'
	},
	airborne: {
		en: 'Airborne',
		de: 'In der Luft',
		ja: '飛行中',
		pt: 'Em voo'
	},
	decisionMaking: {
		en: 'Decision making',
		de: 'Entscheidungsfindung',
		ja: '意思決定',
		pt: 'Tomada de decisão'
	},
	communication: {
		en: 'Communication',
		de: 'Kommunikation',
		ja: 'コミュニケーション',
		pt: 'Comunicação'
	},
	checkIn: {
		en: 'Check-in',
		de: 'Check-in',
		ja: 'チエックイン(業務開始点呼）',
		pt: 'Check-in'
	},
	scramble: {
		en: 'Scramble',
		de: 'Gedrängel',
		ja: 'スクランブル',
		pt: 'Alerta imediato'
	},
	outbound: {
		en: 'Outbound',
		de: 'Ausgehend',
		ja: 'アウトバウンド',
		pt: 'Partida'
	},
	onSite: {
		en: 'On site',
		de: 'Vor Ort',
		ja: 'オンサイト',
		pt: 'No local da ocorrência'
	},
	transportHospital: {
		en: 'Transport hospital',
		de: 'Transpot Krankenhaus',
		ja: '病院へ移送',
		pt: 'Transporte para o hospital'
	},
	day1: {
		en: 'Day 1',
		de: 'Tag 1',
		ja: 'Day 1',
		pt: 'Dia 1'
	},
	day2: {
		en: 'Day 2',
		de: 'Tag 2',
		ja: 'Day 2',
		pt: 'Dia 2'
	},
	day3: {
		en: 'Day 3',
		de: 'Tag 3',
		ja: 'Day 3',
		pt: 'Dia 3'
	},
	day4: {
		en: 'Day 4',
		de: 'Tag 4',
		ja: 'Day 4',
		pt: 'Dia 4'
	},
	finalReflection: {
		en: 'Final reflection',
		de: 'Abschließende Reflexion',
		ja: '最終の振り返り',
		pt: 'Reflexão final'
	},
	finalResults: {
		en: 'Final results',
		de: 'Abschließende Ergebnisse',
		ja: '最終の結果',
		pt: 'Resultados finais'
	},
	totalScore: {
		en: 'Total score',
		de: 'Gesamtpunktzahl',
		ja: 'トータルスコア',
		pt: 'Pontuação total'
	},
	gameover: {
		en: 'Gameover',
		de: 'Gameover',
		ja: 'ゲームオーバー',
		pt: 'Fim do jogo'
	},
	
	game: {
		en: 'Game',
		de: 'Spiel',
		ja: 'ゲーム',
		pt: 'Jogo'
	},
	reflection: {
		en: 'Reflection',
		de: 'Reflexion',
		ja: '振り返り',
		pt: 'Reflexão'
	},
	debrief: {
		en: 'Debrief',
		de: 'Nachbesprechung',
		ja: '終了後打ち合わせ（デブリーフ）',
		pt: 'Debriefing'
	},
	missionDebriefing: {
		en: 'Mission De-briefing',
		de: 'Mission De-Briefing',
		ja: 'ミッションのデブリーフィング',
		pt: 'Debriefing da missão'
	},
	bestPractices: {
		en: 'Best Practices',
		de: 'Beste Praktiken',
		ja: 'ベスト・プラクティス',
		pt: 'Melhores práticas'
	},
	results: {
		en: 'Results',
		de: 'Ergebnisse',
		ja: '結果',
		pt: 'Resultados'
	},	

	firstPhase: {
		en: 'First phase',
		de: 'Erste Phase',
		ja: '最初のフェーズ',
		pt: 'Primeira fase'
	},
	thisPhase: {
		en: 'This phase',
		de: 'Diese Phase',
		ja: 'このフェーズ',
		pt: 'Esta fase'
	},
	nextPhase: {
		en: 'Next phase',
		de: 'Nächste Phase',
		ja: '次のフェーズ',
		pt: 'A próxima fase'
	},
	open: {
		en: 'Open',
		de: 'Offen',
		ja: '開く',
		pt: 'Abrir'
	},
	endGame: {
		en: 'End game',
		de: 'Endspiel',
		ja: 'ゲーム終了',
		pt: 'Fim do jogo'
	}
};

const gameStepsUiTexts = {
	mayday: {
		en: 'MAYDAY',
		de: 'MAYDAY',
		ja: 'メーデー',
		pt: 'MAYDAY'
	},
	introduction: {
		en: 'Introduction',
		de: 'Einleitung',
		ja: 'イントロダクション',
		pt: 'Introdução'
	},
	welcome: {
		en: 'Welcome',
		de: 'Wilkommen',
		ja: 'ようこそ',
		pt: 'Boas-vindas'
	},
	crew: {
		en: 'Crew',
		de: 'Crew',
		ja: 'クルー',
		pt: 'Tripulação'
	},
	selectCrew: {
		en: 'Select crew',
		de: 'Crew auswählen',
		ja: 'クルーの選択',
		pt: 'Selecionar tripulação'
	},
	selectStaff: {
		en: 'Select staff',
		de: 'Mitarbeiter auswählen',
		ja: 'スタッフの選択',
		pt: 'Selecionar pessoal'
	},
	crewSelection: {
		en: 'Crew Selection',
		de: 'Auswahl der Crew',
		ja: 'クルー選択',
		pt: 'Seleção da tripulação'
	},
	selectedStaff: {
		en: 'Selected staff', 
		de: 'Auswahl der Mitarbeiter',
		ja: '選択したクルー',
		pt: 'Pessoal selecionado'
	},
	staffReflection: {
		en: 'Staff reflection',
		de: 'Mitarbeiter Reflexion',
		ja: 'スタッフ反映',
		pt: 'Reflexão do pessoal'
	},
	reflection: {
		en: 'Reflection',
		de: 'Reflexion',
		ja: '振り返り・回想',
		pt: 'Reflexão'
	},
	results: {
		en: 'Results',
		de: 'Ergebnisse',
		ja: '結果',
		pt: 'Resultados'
	},
	checkIn: {
		en: 'Check-in',
		de: 'Check-in',
		ja: 'チエックイン（業務開始時)',
		pt: 'Check-in'
	},
	preflight: {
		en: 'Pre-flight',
		de: 'Pre-flight',
		ja: '飛行前',
		pt: 'Pré-voo'
	},
	boarding: {
		en: 'Boarding',
		de: 'Boarding',
		ja: '飛行機への搭乗',
		pt: 'Embarque'
	},
	cruise: {
		en: 'Cruise',
		de: 'Reiseflug',
		ja: '巡航飛行',
		pt: 'Voo de cruzeiro'
	},
	pilotIncapacitation: {
		en: 'Pilot Incapacitation',
		de: 'Untauglichkeit von Piloten',
		ja: 'パイロットの操縦能力喪失',
		pt: 'Incapacitação do piloto'
	},
	turbulence: {
		en: 'Turbulence',
		de: 'Turbulenzen',
		ja: 'タービュランス',
		pt: 'Turbulência'
	},
	fire: {
		en: 'Fire',
		de: 'Feuer',
		ja: '火災',
		pt: 'Incêndio'
	},
	warnings: {
		en: 'Warnings',
		de: 'Warnungen',
		ja: '警告・警報',
		pt: 'Avisos'
	},
	input: {
		en: 'Input',
		de: 'Input',
		ja: '入力',
		pt: 'Inserção'
	},
	flights: {
		en: 'Flights',
		de: 'Flüge',
		ja: 'フライト',
		pt: 'Voos'
	},
	firstDebrief: {
		en: '1st DEBRIEF',
		de: '1. DEBRIEF',
		ja: '１回目のデブリーフィング',
		pt: '1º DEBRIEF'
	},
	secondDebrief: {
		en: '2nd DEBRIEF',
		de: '2. DEBRIEF',
		ja: '２回目のデブリーフィング',
		pt: '2º DEBRIEF'
	},
	thirdDebrief: {
		en: '3rd DEBRIEF',
		de: '3. DEBRIEF',
		ja: '３回目のデブリーフィング',
		pt: '3º DEBRIEF'
	}
};

const adminUiTexts = {
	admin: 'Admin',
	company: 'Company',
	companies: 'Companies',
	facilitator: 'Facilitator',
	facilitators: 'Facilitators',
	admins: 'Admins',
	newCompany: 'New company',
	createNewCompany: 'Create new company',
	createNewFacilitator: 'Create new facilitator',
	id: 'Id',
	name: 'Name',
	email: 'E-mail',
	date: 'Date',
	created: 'Created',
	lastLogin: 'Last login',
	games: 'Games',
	game: 'Game',
	group: 'Group',
	status: 'Status',
	sendInviteOrReset: 'Send invitation / reset password',
	sendInvite: 'Send invitation',
	notInvited: 'Not invited',
	enabled: 'Enabled',
	disabled: 'Disabled',
	sendEmail: 'Send e-mail',
	scenario: 'Scenario',
	currentPhase: 'Current phase',
	players: 'Players',
	groups: 'Groups',
	saveChanges: 'Save changes',
	disableAccount: 'Disable account',
	activateAccount: 'Activate account',
	deleteAccount: 'Delete account',
	deleteCompany: 'Delete company',
	delete: 'Delete',
	disable: 'Disable',
	cancel: 'Cancel',
	ok: 'Ok',
	createFacilitator: 'Create new facilitator',
	create: 'Create',
	companyName: 'Company name',
	loginMethod: 'Login method',
	importPlayers: 'Import players',
	deleteAllPlayers: 'Delete all players',
	selectedCrew: 'Selected crew',
	reflectionResults: 'Reflection',
	onTheGround: 'On the ground',
	airborne: 'Airborne',
	decisionMaking: 'Decision making',
	communicationTool: 'Communication tool',
	exerciseTool: 'Exercise tool',
	finalReflection: 'Final reflection',
	finalResults: 'Final results',
	confirmDisableFacilitatorPopup: {
		title: 'Disable facilitator',
		text: 'Are you sure you want to disable the account of %name%?<br /><br />They will not be able to log in until you enable it again. Their games will not be deleted.',
		text2: 'You cannot disable your own account.',
	},
	confirmDeleteFacilitatorPopup: {
		title: 'Delete facilitator',
		text: 'Are you sure you want to delete the account of %name%? This will also delete all their games.',
		text2: 'You cannot delete your own account.',
	},
	confirmDeleteCompanyPopup: {
		title: 'Delete company',
		text: 'Are you sure you want to delete the company \'%company%\'?<br /><br />By deleting the company all games, game data and facilitators, belonging to the company will be removed. If needed you can download gamedata before deleting.',
	},
	errorMessages: {
		notAllContentLoaded: 'Error: Could not load all content. Check your internet connection and reload page.',
		noFileSelected: 'Error: No file selected',
		missingProperties: 'Error: Wrong format, could not find "id" and/or "name"',
		formatError: 'Error: Format error',
		missingImports: 'Warning: Not all players could not be imported due to formatting issues',
		unknownError: 'Error: Unknown error',
		noNewData: 'Warning: No new data added'
	},
	importPlayersWarning: 'You need to save the company before you can import players.',
	deleted: 'deleted',
	yes: 'yes',
	no: 'no'
};

module.exports = {
	loginUiTexts,
	settingsUiTexts,
	generalUiTexts,
	gamePhasesUiTexts,
	gameStepsUiTexts,
	adminUiTexts,
};
